/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./language-pack.vue?vue&type=template&id=f9e537da&scoped=true&"
import script from "./language-pack.vue?vue&type=script&lang=js&"
export * from "./language-pack.vue?vue&type=script&lang=js&"
import style0 from "./language-pack.vue?vue&type=style&index=0&id=f9e537da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e537da",
  null
  
)

export default component.exports